export default {
  apiUrl: 'http://0.0.0.0:3000',
  title: 'Global Pandemic Map',
  isUser: false
}



// WEBPACK FOOTER //
// ./src/config.js